import React, { Component } from 'react';
import { connect } from 'react-redux';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import userActions from '../actions/user_actions';
import { closeNamedWindow } from '../utils/popupWindows';

export class Announcement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      announcement: "",
      groups: [],
      filesOpen: {},
      selectedGroupName: '',
      selectedUserId: '',
      selectedUserIds: {},
      showError: false,
    };
  }

  componentDidMount() {
    // Load groups.
    this.getGroups();
  }

  getGroups = () => {
    const token = localStorage.token;
    if (token) {
      return fetch("api/group/list", {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Authorization': `Bearer ${token}`
        }
      })
        .then(resp => resp.json())
        .then(data => {
          var groups = {};
          var groupList = [];
          for (var i = 0; i < data.length; i++) {
            var group = data[i];
            if (!groups.hasOwnProperty(group.groupName)) {
              groups[group.groupName] = [];
            }
            groups[group.groupName].push(group.userId);
          }

          for (var key of Object.keys(groups)) {
            groupList.push({ 'groupName': key, 'userIds': this.sortUserIds(groups[key]) });
          }
          groupList.sort(function (a, b) {
            var groupNameA = a.groupName.toUpperCase();
            var groupNameB = b.groupName.toUpperCase();
            return (groupNameA < groupNameB) ? -1 : (groupNameA > groupNameB) ? 1 : 0;
          });
          this.setState({ groups: groupList });
        });
    }
  }

  convertUserToDisplayName = (user) => {
    return this.props.memberIdMap[user['id']].firstName + " " + this.props.memberIdMap[user['id']].lastName;
  }

  sortUserIds = (userIds) => {
    var newUserIds = [...userIds].filter(id => this.props.memberIdMap.hasOwnProperty(id));
    return newUserIds.sort((a, b) => {
      var nameA = this.convertUserToDisplayName(this.props.memberIdMap[a]);
      var nameB = this.convertUserToDisplayName(this.props.memberIdMap[b]);
      return nameA.localeCompare(nameB);
    });
  }

  handleChange = event => {
    this.setState({ announcement: event.target.value });
  };

  handleSendAnnouncement = () => {
    const token = localStorage.token;
    var recipients = [];
    var allFalse = true;
    for (let property in this.state.selectedUserIds) {
      if (this.state.selectedUserIds[property]) {
        allFalse = false;
      }
    }

    if (allFalse || Object.keys(this.state.selectedUserIds).length === 0 || this.state.announcement === "") {
      this.setState({ showError: true });
    } else {
      for (let property in this.state.selectedUserIds) {
        if (this.state.selectedUserIds[property]) {
          recipients.push(property);
        }
      }
      var request = JSON.stringify({ 'Announcement': this.state.announcement, 'UserIds': recipients });
      fetch("api/post/SendAnnouncement", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: request
      })
      .then(resp => resp.json())
      .then(data => {
      });
      this.setState({ announcement: "", showError: false }, () => {
        closeNamedWindow('MakeAnnouncement');
      });
      }
  };

  handleCancelAnnouncement = () => {
    closeNamedWindow('MakeAnnouncement');
    this.setState({ announcement: "", showError: false });
  };

  handleFilesClick = (groupName) => event => {
    var tempFileOpen = { ...this.state.filesOpen };
    if (!tempFileOpen.hasOwnProperty(groupName)) {
      tempFileOpen[groupName] = true;
    } else {
      tempFileOpen[groupName] = !tempFileOpen[groupName];
    }
    this.setState({ filesOpen: tempFileOpen, selectedGroupName: groupName });
  };

  onClickUser = clickedUserProps => event => {
    this.setState({ selectedGroupName: clickedUserProps['group']['groupName'], selectedUserId: clickedUserProps['id'] });
  };

  handleCheckboxClick = (e, id) => {
    var newIds = { ...this.state.selectedUserIds };
    newIds[id] = e.target.checked;
    this.setState({ 'selectedUserIds': newIds })
  };

  handleGroupCheckboxClick = (e, groupIds) => {
    var newIds = { ...this.state.selectedUserIds };
    for (var i = 0; i < groupIds.length; i++) {
      newIds[groupIds[i]] = e.target.checked;
    }
    this.setState({ 'selectedUserIds': newIds })
  };

  render() {
    const groupList = [];
    this.state.groups.forEach((group, i) => { // this.state.groups = [{groupName: "wellsboro", userIds: ["123abc", "456def"]}, {...}, {...}]
      // Only use users that have an entry in the member id map.
      group['userIds'] = group['userIds'].filter(id => this.props.memberIdMap.hasOwnProperty(id));
      //console.log("group list i: ", i);
      groupList.push(
        <div>
          <List disablePadding style={{ padding: '0px' }}>
            <ListItem key={i} dense onClick={this.handleFilesClick(group['groupName'])} style={{ padding: '0px' }} button>
              <Checkbox
                onChange={(e) => this.handleGroupCheckboxClick(e, group['userIds'])}
                onClick={e => { e.stopPropagation(); }}
                style={{ padding: '2px' }}
              />
              <ListItemText
                disableTypography
                primary={group['groupName']}
                style={{ fontSize: '12px', 'cursor': 'default' }}
              />
              {this.state.filesOpen['groupName'] ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={this.state.filesOpen[group['groupName']]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding style={{ padding: '0px' }}>
                {group.userIds.map((id, j) =>
                  <div>
                    <ListItem key={j} /*role={undefined}*/ dense onClick={this.handlecanManageToggle} style={{ padding: '0px' }}>
                      <ListItemIcon style={{ margin: '0px', paddingLeft: '40px' }}>
                        <Checkbox
                          edge="start"
                          //checked={checked.indexOf(value) !== -1}
                          checked={this.state.selectedUserIds.hasOwnProperty(id) && this.state.selectedUserIds[id]}
                          onChange={(e) => this.handleCheckboxClick(e, id)}
                          //tabIndex={-1}
                          disableRipple
                          style={{ padding: '2px' }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        disableTypography
                        primary={this.props.memberIdMap[id].firstName + " " + this.props.memberIdMap[id].lastName}
                        style={{ fontSize: '12px', 'cursor': 'default' }}
                      />
                    </ListItem>
                  </div>)}
              </List>
            </Collapse>
          </List>
        </div>
      );
    });
    //  // {this.state.showError && <p style={{ color: '#ff0000', fontSize: '10px', paddingTop: '5px', margin: '0px', textAlign: 'center' }}>Please select users and enter announcement</p>}
    return (
        <div style={{ backgroundColor: '#f5f5f5', height: '100%', overflowY: 'hidden', padding: '10px'}}>
         <Grid container spacing={0} justifyContent="center" style={{ }}>
          <Grid item xs={6} style={{ backgroundColor: '#f5f5f5', padding: '5px'}}>
            <Card style={{ height: '270px', maxWidth: '500px', padding: '15px', overflow: 'auto' }}>
              <Typography align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '14px', 'cursor': 'default' }}>
                User List
              </Typography>
              {groupList}
            </Card>
          </Grid>
          <Grid item xs={6} style={{ backgroundColor: '#f5f5f5', padding: '5px'}}>
            <Card style={{ height: '270px', maxWidth: '500px', padding: '5px' }}>
              <Typography align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '14px', 'cursor': 'default' }}>
                Please select the employees from the list on the left to send the announcement to. Then type in a message in the box below and hit send.
              </Typography>
              <TextField
                autoFocus
                variant="outlined"
                margin="normal"
                id="announcement"
                type="name"
                value={this.state.announcement}
                onChange={this.handleChange}
                placeholder="Write an announcement..."
                error={this.state.showError}
                // helperText={this.state.showError ? "Please select users and enter an announcement" : ""}
                fullWidth
                multiline
                minRows="4"
                style={{ marginTop: '0px', padding: '5px 5px 0 5px' }}
                inputProps={{ style: { fontSize: '12px', lineHeight: '14px', height: '60px', padding: '2px' } }}
              />
              <Grid container spacing={0} justifyContent="center" style={{ marginTop: '0px' }}>
                <Button variant="contained" onClick={this.handleSendAnnouncement} color="primary" style={{ marginRight: '5px'}}>
                  Send
                </Button>
                <Button variant="contained" onClick={this.handleCancelAnnouncement} color="primary" style={{ marginLeft: '5px' }}>
                  Cancel
                </Button>
              </Grid>
            </Card>
          </Grid>
        </Grid>
        <Checkbox hidden={true}/>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    members: state.members,
    profile: state.profile,
    currentUser: state.currentUser,
    memberIdMap: state.memberIdMap,
    memberNameMap: state.memberNameMap,
  };
}

const mapDispatchToProps = dispatch => ({
  updateManageUser: user => dispatch(userActions['UPDATE_MANAGE_USER'](user)),
  createManageUser: user => dispatch(userActions['CREATE_MANAGE_USER'](user)),
  deleteManageUser: user => dispatch(userActions['DELETE_MANAGE_USER'](user))
})

export default connect(mapStateToProps, mapDispatchToProps)(Announcement);


// WEBPACK FOOTER //
// ./src/components/Announcement.js